module.exports = __webpack_public_path__ + "static/media/tv-2.b3b51f3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tv-2.jpg
// module id = 124
// module chunks = 0